import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { StyledSnackbar } from '../../theme/Global'
import { alertClose } from '../actions'

const Toast = ({
  message,
  type,
  open,
  alertCloseDispatch,
  duration,
  position
}) => {
  return (
    <StyledSnackbar
      anchorOrigin={position}
      open={open}
      type={type}
      autoHideDuration={duration}
      onClose={alertCloseDispatch}
      message={message}
    />
  )
}

const mapStateToProps = (state) => ({
  message: state.common.alertMessage,
  open: state.common.alertOpen,
  type: state.common.alertType,
  duration: state.common.alertDuration
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  { alertCloseDispatch: alertClose },
  dispatch
)

Toast.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
  alertCloseDispatch: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  duration: PropTypes.number,
  position: PropTypes.object
}

Toast.defaultProps = {
  message: '',
  type: 'info',
  open: false,
  duration: 6000,
  position: {
    vertical: 'bottom',
    horizontal: 'left'
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Toast)
